/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portals_Readiness_EmptyInputs */

const cs_portals_readiness_empty = /** @type {(inputs: Portals_Readiness_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádný povolený portál — matice je prázdná.`)
};

const en_portals_readiness_empty = /** @type {(inputs: Portals_Readiness_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No allowed portal — matrix is empty.`)
};

/**
* | output |
* | --- |
* | "No allowed portal — matrix is empty." |
*
* @param {Portals_Readiness_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const portals_readiness_empty = /** @type {((inputs?: Portals_Readiness_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portals_Readiness_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_portals_readiness_empty(inputs)
	return cs_portals_readiness_empty(inputs)
});